enum ServiceComboTargetClientele {
    AssignedClientele = 0,
    Clinic = 1, // Environnement
    Open = 2,
    Site = 50,
    Organization = 51
}

/**
 * Convert to clientele translated value
 * @param targetedClient The targeted clientele.
 */
function ToTargetedClienteleTranslatedValue(targetedClient: ServiceComboTargetClientele): string {
    switch (targetedClient) {
        case ServiceComboTargetClientele.Open:
            return cacheStore.GetString("IsOpenLabel");
        case ServiceComboTargetClientele.Clinic:
            return cacheStore.GetString("MyleEnvironnementLabel");
        case ServiceComboTargetClientele.AssignedClientele:
            return cacheStore.GetString("AssignedLabel");
        case ServiceComboTargetClientele.Site:
            return cacheStore.GetString("SiteDLabel");
        case ServiceComboTargetClientele.Organization:
            return cacheStore.GetString("OrganizationLabel");
    }
}

export { ServiceComboTargetClientele, ToTargetedClienteleTranslatedValue };
